import cssModule from "@vercel/turbopack-next/internal/font/local/cssmodule.module.css?{%22path%22:%22_app.tsx%22,%22import%22:%22%22,%22arguments%22:[{%22src%22:%22../../public/DepartureMono-Regular.woff2%22}],%22variableName%22:%22departureMono%22}";
const fontData = {
    className: cssModule.className,
    style: {
        fontFamily: "'departureMono', 'departureMono Fallback'",
        
    },
};

if (cssModule.variable != null) {
    fontData.variable = cssModule.variable;
}

export default fontData;
